export type FeatureFlagSourceName = 'cloudbees' | 'connect' | 'config';

export type FeatureFlagSourceNames = Partial<
  Record<FeatureFlagSourceName, string>
>;

/**
 * A flag is identified by its key. Each app owns one of these records, so the
 * set of flags a provider understands is typed by that record, not by this library.
 */
export type FeatureFlagDefinitions<TFlag extends string = string> = Readonly<
  Record<TFlag, FeatureFlagSourceNames>
>;

export const getFlags = <TFlag extends string>(
  definitions: FeatureFlagDefinitions<TFlag>
): TFlag[] => Object.keys(definitions) as TFlag[];

export const getSourceFlagName = <TFlag extends string>(
  definitions: FeatureFlagDefinitions<TFlag>,
  flag: TFlag,
  source: FeatureFlagSourceName
): string | undefined => definitions[flag][source];

export const getSourceFlagNames = <TFlag extends string>(
  definitions: FeatureFlagDefinitions<TFlag>,
  source: FeatureFlagSourceName
): string[] =>
  getFlags(definitions).flatMap(
    (flag) => getSourceFlagName(definitions, flag, source) ?? []
  );
